module.exports = __webpack_public_path__ + "img/慢走丝3.42a22fd0.jpg";